export default __webpack_public_path__ + "static/images/Jeongyeon_1_thumb.png";